import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useProductGroup } from '../../../context/ProductGroupContext/ProductGroupContextProvider';
import Table from '../../../components/common/table/Table';
import { FaTrash } from 'react-icons/fa';
import { MdEdit } from 'react-icons/md';
import CreateProductGroup from './CreateProductGroup';
import { useModal } from '../../../components/common/modal/ModalContext';
import ActionButtons from '../../../components/common/ActionButtons';

const ProductGroupTable = () => {
  const {
    deleteProductGroup,
    clearFormData,
    setCurrentPage,
    pageSize,
    totalElements,
    currentPage,
    getProductGroupByPage,
    setSortBy,
    sortBy,
    sortDir,
    setSortDir,
    searchQuery,
    response,
  } = useProductGroup();
  const { openModal, closeModal } = useModal();

  useEffect(() => {
    const fetchProductGroup = async () => {
      await getProductGroupByPage();
    };
    fetchProductGroup();
    return () => {};
  }, [currentPage, searchQuery]);

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field); // Update the sortBy field
    setSortDir(direction); // Update the sort direction
    const fetchProductGroup = async () => {
      await getProductGroupByPage(
        currentPage,
        pageSize,
        searchQuery,
        field,
        direction,
      ); // Fetch sorted data
    };
    fetchProductGroup();
    return () => {};
  };

  const handleOpenModal = useCallback(
    (user) => {
      clearFormData();
      openModal(
        <CreateProductGroup closeModal={closeModal} data={user} />,
        'Update Product Group',
      );
    },
    [clearFormData, openModal, closeModal],
  );

  const columns = useMemo(
    () => [
      { header: 'Product Group Code', field: 'productGroupCode' },
      { header: 'Product Group Name', field: 'productGroupName' },
      {
        header: 'Main Product Group',
        field: 'mainProductGroup.mainProductGroupName',
      },
      {
        header: 'Power BI Main Product Group',
        field: 'powerBiMainProductGroup.powerBiMainProductGroupName',
      },
      {
        header: 'Sales Department',
        field: 'salesDepartment.salesDepartmentName',
      },
      { header: 'Catalogue No', field: 'catalogueNo' },
      {
        header: 'ACTIONS',
        render: (user) => (
          <ActionButtons
            actions={[
              {
                icon: <FaTrash />,
                onClick: () => deleteProductGroup(user.id),
                tooltip: 'Delete Product Group',
                className: 'text-red-500 pr-5',
              },
              {
                icon: <MdEdit />,
                onClick: () => handleOpenModal(user),
                tooltip: 'Edit Product Group',
                className: 'text-gray-500',
              },
            ]}
          />
        ),
      },
    ],
    [deleteProductGroup, handleOpenModal],
  );

  return (
    <>
      {' '}
      <Table
        columns={columns}
        data={response}
        totalElements={totalElements}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)} // Updated prop name here
        onSortChange={handleSortChange} // Pass sorting handler
        sortConfig={{ field: sortBy, direction: sortDir }} // Pass current sorting state
      />
    </>
  );
};

export default ProductGroupTable;
